import { uniqueId } from "lodash";
import { tileNames, textBlockType, alignmentX, alignmentY } from "../../page/TileConstants";
import { appendPageToTome, appendRowToPageInTome, appendTileToRowInTome } from "../../tome/TomeContext";
import { createTheme } from "../../tome/Themes";

export const makePage = tome => {
	let page = null;
	let row = null;
	let tile = null;

	// Page
	page = appendPageToTome(tome, createTheme());



	// Row
	row = appendRowToPageInTome(page, tome);


	tile = appendTileToRowInTome(
		{
			type: tileNames.IMAGE.name,
			params: {
				image: "/fitwell/phone-mock-1.png",
				imageSize: "contain",
				paddingY: 12,
			},
		},
		row,
		tome,
		4
	);


	tile = appendTileToRowInTome(
		{
			type: tileNames.TEXT.name,
			height6: 5,
			height12: 8,
			params: {
				alignmentX: alignmentX.LEFT,
				alignmentY: alignmentY.MIDDLE,
				blocks: [
					{
						id: uniqueId("block"),
						type: textBlockType.P,
						content: "Mobile",
					},
					{
						id: uniqueId("block_h0_"),
						type: textBlockType.H2,
						content: "Best in class HealthKit integration creates a seamless user experience",
					},
				],
			},
		},
		row,
		tome,
		8
	);
	

	


	row.height = tile.height12;
	row.height = 12;
	return page;
};
